function parseTripDate(value: string): Date | null {
  const normalized = value.includes('T') ? value : `${value.replace(' ', 'T')}Z`
  const date = new Date(normalized)
  return Number.isNaN(date.valueOf()) ? null : date
}

const timeFormatter = new Intl.DateTimeFormat('en-GB', {
  hour: '2-digit',
  minute: '2-digit',
})

const recentDetailFormatter = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
  hour: '2-digit',
  minute: '2-digit',
})

export interface TripStartedPresentation {
  label: string
  detail: string
  title: string
}

export function formatTripStarted(value: string, now = new Date()): TripStartedPresentation {
  const date = parseTripDate(value)
  if (!date) return { label: `Started ${value}`, detail: '', title: value }

  const ageMilliseconds = Math.max(0, now.valueOf() - date.valueOf())
  const ageMinutes = Math.floor(ageMilliseconds / 60_000)
  const exactTitle = new Intl.DateTimeFormat('en-GB', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date)

  if (ageMinutes < 1) {
    return { label: 'Started just now', detail: `(${recentDetailFormatter.format(date)})`, title: exactTitle }
  }
  if (ageMinutes < 60) {
    return {
      label: `Started ${ageMinutes} ${ageMinutes === 1 ? 'min' : 'mins'} ago`,
      detail: `(${recentDetailFormatter.format(date)})`,
      title: exactTitle,
    }
  }

  const ageHours = Math.floor(ageMinutes / 60)
  if (ageHours < 24) {
    return {
      label: `Started ${ageHours} h ago`,
      detail: `(${recentDetailFormatter.format(date)})`,
      title: exactTitle,
    }
  }

  const includeYear = date.getFullYear() !== now.getFullYear()
  const dateLabel = new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    year: includeYear ? 'numeric' : undefined,
  }).format(date)
  return {
    label: `Started ${dateLabel}`,
    detail: `(${timeFormatter.format(date)})`,
    title: exactTitle,
  }
}
